'use client';

import { __assign } from '../_virtual/_tslib.js';
import { useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect.js';

var placements = {
    'top-start': { inset: 'auto auto 0 0' },
    'top-end': { inset: 'auto 0 0 auto' },
    'bottom-start': { inset: '0 auto auto 0' },
    'bottom-end': { inset: '0 0 auto auto' }
};
var usePlacement = function (referrenceElement, popupElement, option) {
    var _a = option || {}, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = _a.spacingElement, spacingElement = _c === void 0 ? 0 : _c;
    var _d = useState(placements[placement]), styles = _d[0], setStyles = _d[1];
    var _e = useState('bottom'), intendedPosition = _e[0], setIntendedPosition = _e[1];
    useIsomorphicLayoutEffect(function () {
        if (referrenceElement && popupElement) {
            if (typeof window === 'undefined')
                return;
            var _a = referrenceElement.getBoundingClientRect(), referrenceHeight = _a.height, top_1 = _a.top, bottom = _a.bottom;
            var height = popupElement.getBoundingClientRect().height;
            var windowHeight = window.innerHeight;
            var placementStyle = {};
            var popupBottomPosition = bottom + height;
            var popupTopPosition = top_1 - height;
            if (placement === 'bottom-start' || placement === 'bottom-end') {
                if (windowHeight < popupBottomPosition) {
                    /* Another placement's style */
                    /* placementStyle = { */
                    /*     ...styles, */
                    /*     transform: `translateY(${windowHeight - popupBottomPosition + GAP}px)` */
                    /* } */
                    if (popupTopPosition < 0)
                        return;
                    if (placement === 'bottom-start') {
                        placementStyle = __assign(__assign({}, styles), placements['top-start']);
                    }
                    if (placement === 'bottom-end') {
                        placementStyle = __assign(__assign({}, styles), placements['top-end']);
                    }
                    placementStyle = __assign(__assign({}, placementStyle), { transform: "translateY(-".concat(referrenceHeight + spacingElement, "px)") });
                    setStyles(placementStyle);
                    setIntendedPosition('top');
                    return;
                }
                placementStyle = __assign(__assign(__assign({}, styles), placements[placement]), { transform: "translateY(".concat(referrenceHeight + spacingElement, "px)") });
                setStyles(placementStyle);
                setIntendedPosition('bottom');
                return;
            }
            if (placement === 'top-start' || placement === 'top-end') {
                if (popupTopPosition < 0) {
                    /* Another placement's style */
                    /* placementStyle = { ...styles, transform: `translateY(${-popupTopPosition - GAP}px)` } */
                    var popupBottomPosition_1 = bottom + height;
                    if (popupBottomPosition_1 > windowHeight)
                        return;
                    if (placement === 'top-start') {
                        placementStyle = __assign(__assign({}, styles), placements['bottom-start']);
                    }
                    if (placement === 'top-end') {
                        placementStyle = __assign(__assign({}, styles), placements['bottom-end']);
                    }
                    placementStyle = __assign(__assign({}, placementStyle), { transform: "translateY(".concat(referrenceHeight + spacingElement, "px)") });
                    setStyles(placementStyle);
                    setIntendedPosition('bottom');
                    return;
                }
                placementStyle = __assign(__assign(__assign({}, styles), placements[placement]), { transform: "translateY(-".concat(referrenceHeight + spacingElement, "px)") });
                setStyles(placementStyle);
                setIntendedPosition('top');
            }
        }
        return function () {
            setStyles(placements[placement]);
        };
    }, [referrenceElement, popupElement]);
    return { styles: styles, intendedPosition: intendedPosition };
};

export { usePlacement as default };
//# sourceMappingURL=usePlacement.js.map
